import Vue3Toastify from "vue3-toastify";
import "vue3-toastify/dist/index.css";

import { toast } from "vue3-toastify";

//import Antd from "ant-design-vue";
// import "ant-design-vue/dist/reset.css";

/*
function resolveGLobalComponents(instance) {
  instance.use(Antd);
}
  resolveGLobalComponents(app);
*/

export default function (app) {
  app.use(Vue3Toastify, {
    //useHandler: resolveGLobalComponents,
    theme: "auto",
    autoClose: 3000,
  });

  app.use({
    intstall(app) {
      app.config.globalProperties.$toast = toast;
    },
  });

  app.config.globalProperties.$toast = toast;
}
